<template>
  <div class="wrap">
    <v-data-table class="app-table" v-model="selected" :headers="headers" :items="data" :single-select="singleSelect" :page.sync="page" :items-per-page="itemsPerPage" hide-default-footer="hide-default-footer" item-key="id" :show-select="mode === 'edit'" @click:row="toMemberPage" @input="updateSelected" @page-count="pageCount = $event" :no-data-text="$t('common.nodata')"></v-data-table>
    <div class="text-center mt-10">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: 'view'
    }
  },
  data () {
    return {
      singleSelect: false,
      selected: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: this.$t('tableMembers.headers.userName'), sortable: false, value: 'userName' },
        { text: this.$t('tableMembers.headers.phoneNumber'), sortable: false, value: 'phoneNumber' },
        { text: this.$t('tableMembers.headers.userEmail'), value: 'userEmail' },
        { text: this.$t('tableMembers.headers.lastRentalAt'), value: 'lastRentalAt' }
      ]
    }
  },
  methods: {
    toMemberPage (data) {
      this.$router.push(`/members/${data.id}`)
    },
    updateSelected (data) {

    }
  }
}
</script>
